export function setTimezones(state, payload) {
    state.timezones = payload
}
export function setQuotes(state, payload) {
    state.quotes = payload
}

export function resetStore(state) {
    state.timezones = []
    state.quotes = ""
}